import { createSlice } from "@reduxjs/toolkit";
import { ofType } from "redux-observable";
import { mergeMap, merge, of } from "rxjs";
import { map, catchError, switchMap } from "rxjs/operators";
import { BalanceResidualLimitVersion } from "@nxplatform/platform-entities/settings";
import { PLATFORM_SETTINGS_FEATURE_KEY } from "@nxplatform/store-shared/platform-settings/shared-platform-settings-feature-keys";
import "@nxplatform/store-shared/platform-settings/shared-platform-settings-selectors";
import { initialPlatformSettingsState } from "./platform-settings.shared.js";
const platformSettingsSlice = createSlice({
  name: PLATFORM_SETTINGS_FEATURE_KEY,
  initialState: initialPlatformSettingsState,
  reducers: {
    getPlatformSettingsStart: (state, action) => {
    },
    platformDataLoaded: (state, action) => {
    },
    platformInitialSetupDataLoaded: (state, action) => {
      const { payload } = action;
      const {
        casino,
        sportsbook,
        config,
        pgw
      } = payload || {};
      state.pgw = pgw;
      const {
        defaultCurrency
      } = config || {};
      state.casino = casino;
      state.sportsbook = sportsbook;
      state.defaultCurrency = defaultCurrency;
      state.casino = casino;
      state.sportsbook = sportsbook;
      state.loaded = true;
    },
    getPlatformSettingsSuccess: (state, action) => {
      state.loaded = true;
      state.fullSettingsLoaded = true;
      const { payload } = action;
      const {
        casino,
        sportsbook,
        config,
        limits,
        pgw,
        termsAcceptRequired,
        integrations
      } = payload || {};
      const {
        websockets,
        limits: limitConfig,
        authorisation,
        sport,
        defaultCurrency,
        bonusesEnabled,
        refProgramEnabled,
        emailHints,
        requiredFieldsFromCashier,
        gamixterEnabled,
        smarticoEnabled
      } = config || {};
      state.casino = casino;
      state.sportsbook = sportsbook;
      state.sport = sport;
      state.authorisation = authorisation;
      state.defaultCurrency = defaultCurrency;
      state.refProgramEnabled = refProgramEnabled;
      state.emailHints = emailHints;
      state.requiredFieldsFromCashier = requiredFieldsFromCashier;
      state.gamixterEnabled = gamixterEnabled;
      state.smarticoEnabled = smarticoEnabled;
      if (typeof bonusesEnabled === "boolean") {
        state.bonusesEnabled = bonusesEnabled;
      }
      if (config) {
        const {
          disablable,
          selfDeleteEnabled,
          selfExclusionEnabled,
          timeoutLimitEnabled,
          fixedSelfExclusion
        } = config.limits || {};
        state.limitsDisablable = disablable || initialPlatformSettingsState.limitsDisablable;
        state.limits.selfDeletionEnabled = selfDeleteEnabled || initialPlatformSettingsState.limits.selfDeletionEnabled;
        state.limits.selfExclusionEnabled = selfExclusionEnabled || initialPlatformSettingsState.limits.selfExclusionEnabled;
        state.limits.timeoutLimitEnabled = timeoutLimitEnabled || initialPlatformSettingsState.limits.timeoutLimitEnabled;
        state.limits.fixedSelfExclusion = fixedSelfExclusion || initialPlatformSettingsState.limits.fixedSelfExclusion;
      }
      state.limits = { ...state.limits, ...limits };
      state.pgw = pgw;
      state.integrations = integrations;
      if (websockets) {
        const { useSockets, isGrpcEnabled } = websockets;
        if (useSockets) {
          state.useSockets = useSockets;
          state.isGrpcEnabled = isGrpcEnabled;
        }
      }
      const {
        inactivityLogoutPeriod,
        bluemRgSmartAssistantEnabled,
        iFinanceCheckEnabled
      } = limitConfig || {};
      state.inactivityLogoutPeriod = inactivityLogoutPeriod;
      state.termsAcceptRequired = termsAcceptRequired;
      if (!state.residualLimitDisableMockVersion1) {
        state.limits.balanceResidualLimitVersion = BalanceResidualLimitVersion.v1;
      }
      if (bluemRgSmartAssistantEnabled) {
        state.bluemRgSmartAssistantEnabled = bluemRgSmartAssistantEnabled;
      }
      if (iFinanceCheckEnabled) {
        state.iFinanceCheckEnabled = iFinanceCheckEnabled;
      }
    },
    resetTextPageState: (state) => {
      state.isTextPage = false;
    },
    resetFrontRenderTextPage: (state) => {
    },
    getPlatformSettingsFailure: (state, action) => {
      state.error = action.payload;
    },
    updateLayoutFreezeState: (state, action) => {
      state.layoutIsFrozen = action.payload;
    },
    togglePersonalCode: (state, action) => {
      state.activePersonalCode = action.payload;
    },
    togglePageState: (state, action) => {
      state.pageExist = action.payload;
    },
    setBffEnabled: (state, action) => {
      state.sportsbook.bffEnabled = action.payload;
    },
    windowPostMessage: () => {
    }
  }
});
const sendWindowPostMessage = (message) => ({
  type: windowPostMessage.type,
  payload: message
});
const platformSettingsReducer = platformSettingsSlice.reducer;
const {
  getPlatformSettingsStart,
  getPlatformSettingsSuccess,
  getPlatformSettingsFailure,
  resetTextPageState,
  updateLayoutFreezeState,
  togglePersonalCode,
  resetFrontRenderTextPage,
  platformDataLoaded,
  togglePageState,
  setBffEnabled,
  windowPostMessage,
  platformInitialSetupDataLoaded
} = platformSettingsSlice.actions;
const platformSettingsEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(getPlatformSettingsStart.type),
  mergeMap(() => merge(
    Api.settings.getSetup().pipe(
      map((data) => platformDataLoaded(data)),
      catchError((err) => of(getPlatformSettingsFailure(err)))
    ),
    Api.settings.getSetupBaseSetup().pipe(
      map((data) => platformInitialSetupDataLoaded(data)),
      catchError((err) => of(getPlatformSettingsFailure(err)))
    )
  ))
);
const platformSettingsList = () => ({
  type: getPlatformSettingsStart.type
});
const customerPersonalCodeEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(togglePersonalCode.type),
  switchMap(() => Api.settings.getSetup().pipe(
    map((data) => platformDataLoaded(data)),
    catchError((err) => of(getPlatformSettingsFailure(err)))
  ))
);
export {
  customerPersonalCodeEpic,
  getPlatformSettingsFailure,
  getPlatformSettingsStart,
  getPlatformSettingsSuccess,
  platformDataLoaded,
  platformInitialSetupDataLoaded,
  platformSettingsEpic,
  platformSettingsList,
  platformSettingsReducer,
  platformSettingsSlice,
  resetFrontRenderTextPage,
  resetTextPageState,
  sendWindowPostMessage,
  setBffEnabled,
  togglePageState,
  togglePersonalCode,
  updateLayoutFreezeState,
  windowPostMessage
};
